(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/slicedToArray", "base64url"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/slicedToArray"), require("base64url"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.slicedToArray, a.base64url), a.jwt = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c) {
  "use strict";

  var d = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.checkTokenValidity = a.getTokenPayload = void 0, b = d(b), c = d(c);
  /**
  * Returns decoded JWT token payload
  */

  var e = function e(a) {
    if (!a) return {};
    var d = a.split("."),
        e = (0, b.default)(d, 2),
        f = e[1],
        g = void 0 === f ? "" : f,
        h = g.replace("-", "+").replace("_", "/");

    try {
      return JSON.parse(c.default.decode(h));
    } catch (a) {
      return {};
    }
  };
  /**
  * Return wether given JWT token is still valid
  */


  a.getTokenPayload = e;

  a.checkTokenValidity = function (a) {
    if (!a) return null;
    var b = e(a),
        c = b.exp,
        d = Date.now() >= 1e3 * c;
    return c && !d;
  };
});